/**
 * Copyright © Ircam Amplify 2024-2026
 */

import { TaskUtil } from '@/pages/TaskList/TaskUtil'
import { useEffect, useState } from 'react'
import './StatusComp.css'

interface StatusCompProps {
  status?: string
  forWebhooks?: boolean
}

function StatusComp({ status = '', forWebhooks }: StatusCompProps) {
  const [statusName, setStatusName] = useState('')

  useEffect(() => {
    if (forWebhooks) {
      switch (status) {
        case 'success':
          setStatusName('Success')
          break
        case 'error':
          setStatusName('Error')
          break
        default:
          setStatusName(TaskUtil.jobStatusToFormattedString(status) ?? '')
      }
    } else {
      setStatusName(TaskUtil.jobStatusToFormattedString(status) ?? '')
    }
  }, [status])

  return (
    <div className={`status-comp ${status}`}>
      <div className="status-led" />
      {statusName}
    </div>
  )
}

export default StatusComp
